import { useRef, useState, useLayoutEffect } from 'react'
import Image from 'next/image'
import { motion, useViewportScroll, useTransform } from 'framer-motion'

export const HomeBillboard = () => {
  const ref = useRef(null)
  const [elementPos, setElementPos] = useState(0)
  const { scrollY } = useViewportScroll()
  const y = useTransform(scrollY, [elementPos - 1, elementPos, elementPos + 1], [0.25, 0, -0.25], { clamp: false })

  useLayoutEffect(() => {
    const element = ref.current
    // Get y-axis midpoint of element when at y-axis midpoint of viewport
    setElementPos((element.offsetTop + (element.offsetHeight / 2)) - (window.innerHeight / 2))
  }, [ref])

  return (
    <div className='home-billboard'>
      <div ref={ref} className='home-billboard__container'>
        <div className='home-billboard__img'>
          <Image
            layout={'fill'}
            objectFit={'cover'}
            objectPosition={'50% 0'}
            src={'/assets/img/home-billboard@2x.jpg'}
            alt='' />
        </div>
        <motion.div
          className='home-billboard__details'
          style={{y: y}}
        >
          <h3 className='home-billboard__details-title'>Map out the career<br /> you want</h3>
        </motion.div>
      </div>
    </div>
  )
}
